{
  "url": "wss://laboxmedicale.com/cable"
}